import "react-photo-album/rows.css";
import {
  createFileRoute,
  useNavigate,
} from "@tanstack/react-router";
import { useVenueDetailsBySlug } from "common/hooks";
import { Storage } from "common/storage";
import { useGeoLocation } from "@/hooks/useGeoLocation";
import "react-medium-image-zoom/dist/styles.css";
import VenuePhotosContent from "@/components/VenueDetailSheet/components/VenuePhotosContent";
import { defaultRegion } from "common/config";

// Define the type for the search params
type VenuePhotosOptions = {
  reviewId?: string;
  sort: "latest" | "earliest" | "category";
  area?: string;
  mode?: string;
};

function VenuePhotos() {
  const { venueSlug: routeSlug } = Route.useParams();
  const { sort, area, mode } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  
  const { location } = useGeoLocation();

    // Use the venue details hook to fetch all venue data including photos
    const {
      data,
      error,
      isLoading,
      refetch: loadVenueDetails
    } = useVenueDetailsBySlug({
      slug: routeSlug,
      latitude: location?.latitude.toString() || defaultRegion.latitude.toString(),
      longitude: location?.longitude.toString() || defaultRegion.longitude.toString(),
      accessToken: Storage.getCurrentUserToken(),
      enabled: true
    });
  
  return (
    <VenuePhotosContent
      venueDetailsResponse={data}
      sort={sort}
      area={area}
      isLoading={isLoading}
      onRefresh={loadVenueDetails}
      onFlag={(image) => {
        // optional callback if you want to handle flag action in parent
      }}
      onBack={() => navigate({ to: `/venuedetails/${routeSlug}` })}
      mode={mode}
    />
  );
}

export const Route = createFileRoute("/venuephotos/$venueSlug")({
  component: VenuePhotos,
  validateSearch: (search: Record<string, unknown>): VenuePhotosOptions => {
    // validate and parse the search params into a typed state
    return {
      sort: (search.sort as "latest" | "earliest" | "category") || "category",
      reviewId: search.reviewId as string | undefined,
      area: search.area as string | undefined,
      mode: search.mode as string | undefined,
    };
  },
});
